import React, { useEffect, useState } from "react";

function Pagination({ totalPages, currentPage, setCurrentPage }: any) {
  const [pagesToShow, setPagesToShow] = useState(2);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Create an event listener to update the innerWidth when the window is resized
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  // Add the event listener when the component mounts
  useEffect(() => {
    window.addEventListener("resize", handleResize);

    // Remove the event listener when the component unmounts to prevent memory leaks
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    if (windowWidth < 640) {
      setPagesToShow(1);
    } else {
      setPagesToShow(2);
    }
  }, [windowWidth]);

  // Create an array of page numbers to display
  const pageNumbers = [];

  if (totalPages <= pagesToShow * 2 + 1) {
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
  } else if (currentPage <= pagesToShow + 2) {
    for (
      let i = 1;
      i <= pagesToShow * 2 + (pagesToShow % 2 === 0 ? 1 : 2);
      i++
    ) {
      pageNumbers.push(i);
    }
    pageNumbers.push("...");
    pageNumbers.push(totalPages);
  } else if (currentPage >= totalPages - pagesToShow - 1) {
    pageNumbers.push(1);
    pageNumbers.push("...");
    for (let i = totalPages - (pagesToShow * 2 + 1); i <= totalPages; i++) {
      pageNumbers.push(i);
    }
  } else {
    pageNumbers.push(1);
    pageNumbers.push("...");
    for (
      let i = currentPage - pagesToShow;
      i <= currentPage + pagesToShow;
      i++
    ) {
      pageNumbers.push(i);
    }
    pageNumbers.push("...");
    pageNumbers.push(totalPages);
  }

  return (
    <div className="flex flex-wrap items-center justify-center gap-2">
      {pageNumbers.map((pageNumber, index) => {
        const isActive = pageNumber === currentPage;
        const isEllipsis = pageNumber === "...";
        return (
          <button
            key={index}
            type="button"
            disabled={isEllipsis}
            onClick={() => {
              if (typeof pageNumber === "number") {
                setCurrentPage(pageNumber);
              }
            }}
            className={`flex h-9 w-9 items-center justify-center rounded-full text-sm font-medium transition-colors duration-200 ${
              isActive
                ? "bg-[var(--red,#F50537)] text-white shadow-[0_2px_10px_rgba(245,5,55,0.4)]"
                : isEllipsis
                ? "cursor-default text-white/40"
                : "border border-white/10 bg-white/5 text-white/70 hover:border-white/25 hover:bg-white/10 hover:text-white"
            }`}
          >
            {pageNumber}
          </button>
        );
      })}
    </div>
  );
}

export default Pagination;